import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const canUpdatePartnerAddressPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'partner_addresses.update');

export const canRemovePartnerAddressPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'partner_addresses.remove');
